import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance2448xvec7zq5m as Data_getInstance } from './adapter/DeletePartyMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeletePartyMutation_VariablesAdapter_instance3dxdl476begu0 as DeletePartyMutation_VariablesAdapter_instance } from './adapter/DeletePartyMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deleteParty) {
        this.k6f_1 = deleteParty;
      }
      toString() {
        return 'Data(deleteParty=' + this.k6f_1 + ')';
      }
      hashCode() {
        return this.k6f_1 == null ? 0 : getBooleanHashCode(this.k6f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.k6f_1 == other.k6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.l6f_1 = '4a11a1598f90772d3be13efb9b91b8b2c0c7c3bbeae17a79a444936647ab7009';
        this.m6f_1 = 'deleteParty';
      }
      a6f() {
        return 'mutation deleteParty($input: DeletePartyInput!) { deleteParty(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DeletePartyMutationClass;
function DeletePartyMutation() {
  if (DeletePartyMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.n6f_1 = input;
      }
      c6f() {
        return '4a11a1598f90772d3be13efb9b91b8b2c0c7c3bbeae17a79a444936647ab7009';
      }
      operationId() {
        return this.c6f();
      }
      u47() {
        return Companion_instance.a6f();
      }
      d6f() {
        return 'deleteParty';
      }
      operationName() {
        return this.d6f();
      }
      o46(writer, customScalarAdapters, withDefaultValues) {
        DeletePartyMutation_VariablesAdapter_instance.o6f(writer, this, customScalarAdapters, withDefaultValues);
      }
      n46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'DeletePartyMutation(input=' + this.n6f_1.toString() + ')';
      }
      hashCode() {
        return this.n6f_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePartyMutation()))
          return false;
        if (!this.n6f_1.equals(other.n6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePartyMutation', VOID, VOID, [Mutation()]);
    DeletePartyMutationClass = $;
  }
  return DeletePartyMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data3reuiwuuk86jk,
  DeletePartyMutation as DeletePartyMutationn87apg3zfg0d,
};
//endregion

//# sourceMappingURL=DeletePartyMutation.mjs.map
